import { useCallback, useEffect, useRef, useState } from "react";
import ActionHeader from "./ActionHeader/ActionHeader";
import styled from "styled-components";
import ToolbarHeader from "./Toolbar/ToolbarHeader";
import PagePermissionWarning from "./PagePermissionWarning/PagePermissionWarning";
import ActionTool from "./Toolbar/ActionTool";
import { ActionEnum } from "../../components/SntTableViewCard/ActionEnum";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Container = styled.div`
  display: flex;
  border: 1px solid red;
  height: 100px;
  flex-wrap: wrap;
  column-gap: 40px;
  background: lightblue;
`;

interface NumberOfAssetState {
  countAll: number;
  countByFilter: number;
  loading: boolean;
}

interface AdminLayoutProps {
  headerTitle?: string;
  extraTitle?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  newButton?: any;
  isAdvanceFilter?: boolean;
  /** See ToolbarHeader.orgId — the organisation the filter list describes. */
  orgId?: number | null;
  totalText?: string;
  body?: (params: {
    isDisabled: boolean;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dataOptions: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onChangeChildren: any;
  }) => React.ReactNode;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  reload?: any;
  pageName?: string;
  sharedKey?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  defaultOption?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  restrictedFilters?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  toolList?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  filterToolList?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  switchMap?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  viewMode?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleActionData?: (id: any) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChangeSimpleFilterList?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getOptionSettingsState?: () => any;
  browserTabTitle?: string;
  isShowBackHistory?: boolean;
  backTo?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onModeChange?: any;
  searchPlaceholder?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onFilterChanged?: (query: any) => void;
  isHideTheSearchUI?: boolean;
  showPermissionWarning?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  filterListRef?: any;
  disabled?: boolean;
  onClearAllButtonClicked?: () => void;
  topContent?: () => React.ReactNode;
  isShowHeader?: boolean;
  includeDynamicFilter?: boolean;
  renderEmptyData?: () => React.ReactNode;
  numberOfAssetState?: NumberOfAssetState;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  forceFilterAction?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setForceFilterAction?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onLoadFilter?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  reloadSessionState?: any;
}

const AdminLayout = ({
  headerTitle = "",
  extraTitle = "",
  newButton,
  // {
  //   disabled: false,
  //   isShow: false,
  //   link: "/",
  //   label: "language.add_key",
  //   onClick: function () {},
  // },
  isAdvanceFilter,
  orgId,
  totalText,
  body,
  reload,
  pageName,
  sharedKey,
  defaultOption,
  restrictedFilters,
  toolList,
  filterToolList,
  switchMap,
  viewMode,
  handleActionData,
  onChangeSimpleFilterList,
  getOptionSettingsState,
  browserTabTitle,
  isShowBackHistory,
  backTo,
  onModeChange,
  searchPlaceholder,
  onFilterChanged,
  isHideTheSearchUI = false,
  showPermissionWarning,
  filterListRef,
  disabled = false,
  onClearAllButtonClicked,
  topContent,
  isShowHeader = true,
  includeDynamicFilter = true,
  renderEmptyData,
  numberOfAssetState,
  forceFilterAction,
  setForceFilterAction,
  onLoadFilter,
  reloadSessionState = null,
}: AdminLayoutProps) => {
  const [title, setTitle] = useState(""); // title of action header
  const [isChanged, setChanged] = useState(false); // is the loaded filter changed
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [dataOptions, setDataOptions] = useState<any>(null); // the filter state (bad name)
  const [numberOfAsset, setNumberOfAsset] = useState<NumberOfAssetState>({
    countAll: 0,
    countByFilter: 0,
    loading: true,
  }); // item counts
  const [isDisabledTable, setDisabledTable] = useState(true); // is there a table ?
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [initialDataOptions, setInitialDataOptions] = useState<any>(null); // the default filter state

  const firstRun = useRef(true); // first load of the component ?
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const currentCols = useRef<any[]>([]); // need this to detect column change by children
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const currentQueries = useRef<any>({}); // need this to detect filter change by children
  const duplicateTitle = useRef(title); // use duplicate to reuse value before render
  const isFilterLoaded = useRef(false); // are we using a loaded filter ?
  const isApplingFilter = useRef(false); // are we first-time applying a loaded filter ?
  const duplicateChanged = useRef(isChanged); // duplicate, for what ?
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const previousOptionSettings = useRef<any>({}); // yet another useref ?

  useEffect(() => {
    if (numberOfAssetState) {
      setNumberOfAsset(numberOfAssetState);
    }
  }, [numberOfAssetState]);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const setInitialData = (newOptions: any) => {
    setInitialDataOptions(newOptions);
    if (newOptions.optionsSettings) {
      isFilterLoaded.current = newOptions.optionsSettings.isFilterLoaded
        ? newOptions.optionsSettings.isFilterLoaded
        : false;

      setChanged(newOptions.optionsSettings.isChanged);
      duplicateChanged.current = newOptions.optionsSettings.isChanged;

      setTitle(newOptions.optionsSettings.title);
      duplicateTitle.current = newOptions.optionsSettings.title;

      setDataOptions({ ...newOptions });
    }
  };

  const getSessionState = () => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let optionsSettings: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let newOptions: any;
    if (getOptionSettingsState) {
      optionsSettings = getOptionSettingsState();
      newOptions = {
        optionsSettings: optionsSettings,
        filtersVisibleAtInit: defaultOption.filtersVisibleAtInit,
        categories: defaultOption.categories,
        deviceCategorySuggestion: defaultOption.deviceCategorySuggestion,
        queryObjectType: defaultOption.queryObjectType,
        pageName: defaultOption.pageName,
      };
    } else {
      const stored = pageName ? sessionStorage.getItem(pageName) : null;
      if (stored) {
        optionsSettings = JSON.parse(stored);
      } else {
        optionsSettings = {};
      }

      if (sharedKey) {
        const lastState = sessionStorage.getItem(sharedKey);
        if (lastState) {
          const obj = JSON.parse(lastState);

          optionsSettings.query = obj.query || [];
          optionsSettings.title = obj.title;
          optionsSettings.isChanged = obj.isChanged;
          optionsSettings.isFilterLoaded = obj.isFilterLoaded;
        }
      }

      newOptions = {
        optionsSettings: optionsSettings.query
          ? optionsSettings
          : defaultOption.optionsSettings || {},
        filtersVisibleAtInit: defaultOption.filtersVisibleAtInit,
        queryObjectType: defaultOption.queryObjectType,
        categories: defaultOption.categories,
        deviceCategorySuggestion: defaultOption.deviceCategorySuggestion,
        pageName: defaultOption.pageName,
      };
    }

    isApplingFilter.current =
      optionsSettings && optionsSettings.isFilterLoaded ? true : false;
    setInitialData(newOptions);
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const setSessionState = (data: any) => {
    const oldOptionsSettings = pageName
      ? sessionStorage.getItem(pageName)
      : null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let parsedOldSettings: any = null;
    if (oldOptionsSettings) {
      parsedOldSettings = JSON.parse(oldOptionsSettings);
    }
    // keep old states
    if (parsedOldSettings) {
      data.tableSettings =
        data.tableSettings || parsedOldSettings.tableSettings;
      data.currentBounds =
        data.currentBounds || parsedOldSettings.currentBounds;
    }

    const _data = {
      searchQueryType: data.searchQueryType,
      query: data.query || [],
      page: data.page,
      start: data.start,
      limit: data.limit,
      orderData: data.orderData,
      tableSettings: data.tableSettings,
      title: duplicateTitle.current,
      isChanged: duplicateChanged.current,
      isFilterLoaded: isFilterLoaded.current,
      currentBounds: data.currentBounds,
    };

    if (pageName) {
      sessionStorage.setItem(pageName, JSON.stringify(_data));
    }
    previousOptionSettings.current = _data;
    if (sharedKey) {
      sessionStorage.setItem(
        sharedKey,
        JSON.stringify({
          query: dataOptions.optionsSettings.query,
          title: duplicateTitle.current,
          isChanged: duplicateChanged.current,
          isFilterLoaded: isFilterLoaded.current,
        })
      );
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const onChangeChildren = (_data: any, numberAsset?: NumberOfAssetState) => {
    if (_data) {
      if (isFilterLoaded.current) {
        const _tableSettings = _data.tableSettings || {
          columnVisibleInOrder: null,
        };
        const _query = _data.query || null;
        if (
          !isApplingFilter.current &&
          (JSON.stringify(currentCols.current) !==
            JSON.stringify(_tableSettings.columnVisibleInOrder) ||
            JSON.stringify(currentQueries.current) !== JSON.stringify(_query))
        ) {
          currentCols.current = JSON.parse(
            JSON.stringify(_tableSettings.columnVisibleInOrder)
          );
          currentQueries.current = JSON.parse(JSON.stringify(_query));
          setChanged(true);
          duplicateChanged.current = true;
        } else {
          isApplingFilter.current = false;
          setChanged(false);
          duplicateChanged.current = false;
        }
      }
      setSessionState(_data);
    }
    if (numberAsset) {
      setNumberOfAsset({ ...numberAsset, loading: false });
    } else if (numberOfAsset.loading) {
      setNumberOfAsset({ ...numberOfAsset, loading: false });
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const onChangeFilter = (_data: any, action?: any) => {
    // set new data options
    const _dataOptions = dataOptions || defaultOption;
    const newOptions = _dataOptions.optionsSettings;
    newOptions.query = _data.query;
    newOptions.searchQueryType = _data.searchQueryType;
    if (isFilterLoaded.current) {
      newOptions.tableSettings =
        initialDataOptions.optionsSettings.tableSettings;
    }
    _dataOptions.optionsSettings = newOptions;

    setDataOptions({
      ..._dataOptions,
      optionsSettings: newOptions,
      action: isApplingFilter.current
        ? { type: ActionEnum.LOAD_FILTER }
        : action,
    });

    setDisabledTable(false);
    onFilterChanged?.(_data.query);
  };

  const handleTools = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (id: any) => {
      switch (id) {
        default:
          handleActionData?.(id);
      }
    },

    [handleActionData]
  );

  useEffect(() => {
    //TODO to be checked why we do this here?
    if (isAdvanceFilter && reloadSessionState !== null) {
      getSessionState();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reloadSessionState]);

  useEffect(() => {
    if (isAdvanceFilter) {
      getSessionState();
    } else {
      setInitialDataOptions(defaultOption);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isAdvanceFilter) {
      if (!firstRun.current && dataOptions) {
        setInitialData({ ...dataOptions });
      }
      firstRun.current = false;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reload]);

  return (
    <>
      {showPermissionWarning ? (
        <PagePermissionWarning pageName={pageName} />
      ) : (
        ""
      )}

      {isShowHeader && (browserTabTitle || title || headerTitle) && (
        <ActionHeader
          title={`${(title || headerTitle) + (isChanged ? " *" : "")} ${
            extraTitle || ""
          }`.trim()}
          tabTitle={browserTabTitle || title || headerTitle}
          isShowBackHistory={isShowBackHistory}
          backTo={backTo}
          toolbar={
            <div
              className={`w-100 ${
                numberOfAsset.countAll === 0 &&
                !numberOfAsset.loading &&
                renderEmptyData
                  ? "d-none"
                  : ""
              }`}
            >
              <ActionTool
                list={toolList}
                onClick={handleTools}
                group={
                  switchMap && { viewMode: viewMode, onChange: onModeChange }
                }
                heroAction={newButton}
              />
            </div>
          }
        />
      )}

      <div
        className={`${
          numberOfAsset.countAll === 0 &&
          !numberOfAsset.loading &&
          renderEmptyData
            ? ""
            : "d-none"
        }`}
      >
        {renderEmptyData && renderEmptyData()}
      </div>

      <div
        className={`${
          numberOfAsset.countAll === 0 &&
          !numberOfAsset.loading &&
          renderEmptyData
            ? "d-none"
            : ""
        }`}
      >
        {topContent && topContent()}
        {initialDataOptions && (
          <ToolbarHeader
            onLoadFilter={onLoadFilter}
            restrictedFilters={restrictedFilters}
            onChange={onChangeFilter}
            dataOptions={initialDataOptions}
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            {...({ numberAsset: numberOfAsset, pageName } as any)}
            filterToolList={filterToolList}
            handleTool={handleTools}
            isAdvanceFilter={isAdvanceFilter}
            orgId={orgId}
            totalText={totalText}
            onChangeSimpleFilterList={onChangeSimpleFilterList}
            searchPlaceholder={searchPlaceholder}
            isHideTheUI={isHideTheSearchUI}
            filterListRef={filterListRef}
            disabled={disabled}
            onClearAllButtonClicked={onClearAllButtonClicked}
            includeDynamicFilter={includeDynamicFilter}
            forceFilterAction={forceFilterAction}
            setForceFilterAction={setForceFilterAction}
          >
            {() =>
              body?.({
                isDisabled: isDisabledTable,
                dataOptions: dataOptions,
                onChangeChildren: onChangeChildren,
              })
            }
          </ToolbarHeader>
        )}
      </div>
      {/*</Container>*/}
    </>
  );
};
export default AdminLayout;
